import axios from "axios";
import config from "../config";

const https = require('https');

const agent = new https.Agent({
    rejectUnauthorized: false,
});

const instance = axios.create({
    baseURL: config.WS_BASE_URL,
});

instance.interceptors.request.use(async(config) => {
    config.httpsAgent = agent
    const token = localStorage.getItem("token");
    config.headers.Authorization = token ? token : "";
    config.headers.ContentType = "application/json";
    return config;
});

export const getByDate = async(date) =>
    await instance.post("schedule/bydate", { date });

export const updateEvents = async(events) =>
    await instance.post("schedule/update", { events });

export const deleteEvent = async(elementId,targetId,sTime) =>
    await instance.post("schedule/delete", { elementId,targetId,sTime });

export const payrollByDate = async(sDate,eDate) =>
    await instance.post("schedule/payroll/bydate", { sDate,eDate });


    //Old Schedule routes

export const getScheduleSettings = async() =>
    await instance.post('/schedule/getsettings');

export const getScheduleEvents = async() =>
    await instance.post('/schedule/getevents');

export const clockInOutAPI = async(data, user) =>
    await instance.post('/schedule/clockinout', { data, user });

export const getPayroll = async(sDate) =>
    await instance.post('/schedule/payroll', { sDate })

export const getIcal = async() =>
    await instance.post('/schedule/geticall')

export const manualClock = async(managerID,userID,time,inOut,location) =>
    await instance.post('/schedule/manualclock',{managerID,userID,time,inOut,location})

export const last20Clocks = async(userID) =>
    await instance.post('/schedule/last20clocks',{userID})

export const payEmployee = async(ids,userAccomodation) =>
    await instance.post('/schedule/pay',{ids,userAccomodation})


export const openDoorAPI = async() =>
    await instance.post('/users/opendoor')

export const getClosedDays = async() =>
    await instance.post('/users/posclose')


export const tester = async() =>
    await instance.post('/');